<div *ngIf="nodeValue" class="bg-bluegray-50 h-full">
   <div
      class="bg-white flex flex-column justify-content-between align-items-center gap-3 w-full px-3 border-bottom-1 border-200"
   >
      <span class="cursor-pointer w-full justify-content-end flex pt-4 mr-2" (click)="this.closeSidebar.emit()">
         <i class="text-bluegray-800 pi pi-times"></i>
      </span>

      <div class="flex justify-content-start align-items-center gap-3">
         <div class="bg-blue-50 p-3 border-1 border-blue-100 border-round-lg">
            <i class="pi pi-sitemap text-blue-700 text-lg"></i>
         </div>
         <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
            Nodo experimento
            <div class="text-sm font-normal text-600">
               El nodo de experimento permite definir, de forma condicional, el porcentaje de casos que se distribuyen
               hacia cada una de sus ramas
            </div>
         </div>
      </div>

      <div class="flex justify-content-center mb-4">
         <p-selectButton
            [options]="visibleTabs()"
            [ngModel]="activeTab()"
            (ngModelChange)="activeTab.set($event)"
            optionLabel="label"
            optionValue="value"
         ></p-selectButton>
      </div>
   </div>

   <div *ngIf="activeTab() === 'preview'" class="p-3 pb-4">
      <div
         class="bg-gradient-to-br from-cyan-50 to-teal-50 dark:from-cyan-950/20 dark:to-teal-950/20 rounded-2xl border border-border"
      >
         <label class="font-semibold text-800">División de tráfico</label>

         <!-- Visual Split -->
         <div class="bg-card rounded-xl p-4 border border-border mb-4">
            <div class="flex h-15 border-round-md rounded-lg overflow-hidden">
               <div
                  class="bg-cyan-500 pl-2 flex items-center justify-center text-white font-bold transition-all duration-300"
                  [style.width.%]="percentageA()"
               >
                  {{ percentageA() && percentageA() > 15 ? percentageA() + '%' : '' }}
               </div>
               <div
                  class="bg-teal-500 pl-2 flex items-center justify-center text-white font-bold transition-all duration-300"
                  [style.width.%]="100 - (percentageA())"
               >
                  {{ percentageA() && 100 - percentageA() > 15 ? 100 - percentageA() + '%' : '' }}
               </div>
            </div>
         </div>

         <!-- Variants Info -->
         <div class="grid gap-3 px-4">
            <div class="col bg-cyan-100 dark:bg-cyan-900/30 rounded-xl p-4 border border-cyan-200 dark:border-cyan-800">
               <div class="flex items-center gap-2 mb-2">
                  <div class="w-1rem h-1rem border-circle bg-cyan-500"></div>
                  <p class="font-semibold text-cyan-700 dark:text-cyan-300">{{  'Variante A' }}</p>
               </div>
               <p class="text-4xl font-bold text-cyan-600 mb-0">{{ percentageA() }}%</p>
               <p class="text-medium text-cyan-600">del tráfico</p>
            </div>

            <div class="col bg-teal-100 dark:bg-teal-900/30 rounded-xl p-4 border border-teal-200 dark:border-teal-800">
               <div class="flex items-center gap-2 mb-2">
                  <div class="w-1rem h-1rem border-circle bg-teal-500"></div>
                  <p class="font-semibold text-teal-700">{{  'Variante B' }}</p>
               </div>
               <p class="text-4xl font-bold text-teal-600 mb-0">{{ 100 - (percentageA()) }}%</p>
               <p class="text-medium text-teal-600">del tráfico</p>
            </div>
         </div>
      </div>
   </div>

   <!-- Config Tab -->
   <div *ngIf="activeTab() === 'config'" class="p-3 pb-4">
      <div class="flex flex-column gap-3">
         <!-- Percentage Slider -->
         <label class="font-semibold text-800">División de tráfico</label>
         <label class="text-500 text-sm"
            >Ajusta el porcentaje de usuarios que irán por cada variante del experimento</label
         >

         <div class="bg-card border-round-md p-4 border border-border mb-2">
            <div class="flex h-15 border-round-md overflow-hidden">
               <div
                  class="bg-cyan-500 pl-2 flex items-center justify-center text-white font-bold transition-all duration-300"
                  [style.width.%]="percentageA()"
               >
                  {{ percentageA() > 15 ? percentageA() + '%' : '' }}
               </div>
               <div
                  class="bg-teal-500 pl-2 flex items-center justify-center text-white font-bold transition-all duration-300"
                  [style.width.%]="percentageB()"
               >
                  {{ percentageB() > 15 ? percentageB() + '%' : '' }}
               </div>
            </div>
         </div>

         <!-- Slider -->
         <div class="flex flex-column gap-3 align-items-center">
            <p-slider
               class="px-4 w-full"
               styleClass="w-full"
               [(ngModel)]="percentageA"
               [min]="0"
               [max]="100"
               [style]="{ width: '100%' }"
               (onChange)="onSliderChange()"
            ></p-slider>

            <div class="flex flex-row gap-4 pt-3">
               <div>
                  <label class="text-600 font-medium flex flex-row gap-2">
                     <div class="align-items-center w-1rem h-1rem border-circle bg-cyan-500"></div>
                     Variante A (%)</label
                  >
                  <input
                     pInputText
                     type="number"
                     [value]="percentageA()"
                     (input)="updatePercentageA($any($event.target).valueAsNumber)"
                     class="w-full rounded-lg border p-1"
                  />
               </div>
               <div>
                  <label class="text-600 font-medium flex flex-row gap-2">
                     <div class="align-items-center w-1rem h-1rem border-circle bg-teal-500"></div>
                     Variante B (%)</label
                  >
                  <input
                     pInputText
                     type="number"
                     [value]="percentageB()"
                     (input)="updatePercentageB($any($event.target).valueAsNumber)"
                     class="w-full rounded-lg border p-1"
                  />
               </div>
            </div>
         </div>

         <label class="font-semibold text-800 pt-2">División rápidas</label>
         <div class="flex flex-wrap gap-2 py-2">
            <div
               *ngFor="let preset of presets"
               (click)="applyPreset(preset.a)"
               class="cursor-pointer border-round-md px-4 py-2 transition-all duration-200"
               [ngClass]="
                  percentageA() === preset.a ? 'border-1 border-cyan-600 bg-cyan-50' : 'border border-gray-300 bg-white'
               "
            >
               {{ preset.label }}
            </div>
         </div>

         <div *ngIf="errors().length">
            <div *ngFor="let e of errors()" class="text-red-600">{{ e.errorMessage }}</div>
         </div>
      </div>
   </div>
</div>
